import {Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Favorite, FavoriteList, FavoriteListPaginated} from '@models/favorite';
import {AdService} from '@services/ad.service';
import {EMPTY_FAVORITE_LIST, EMPTY_USER, EVOL_DEMO_LAST_YEAR} from '@models/empty';
import * as _ from 'underscore';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CommonService} from '@services/common.service';
import {City} from '@models/city';
import {User} from '@models/user';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {CityService} from '@services/city.service';
import {OnboardingService} from '@services/onboarding.service';
import {SharePopupComponent} from '@module/favorites/list/share-popup/share-popup.component';
import {RenamePopupComponent} from '@module/favorites/list/rename-popup/rename-popup.component';
import {AddComponent} from '@module/favorites/popup/add/add.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {Title} from '@angular/platform-browser';
import {AlertService} from '@services/alert.service';
import {NewPopupComponent} from '@module/favorites/list/new-popup/new-popup.component';
import {UserService} from '@services/user.service';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {NotesComponent} from '@module/favorites/popup/notes/notes.component';
import {OrderListPopupComponent} from '@module/favorites/list/order-list-popup/order-list-popup.component';
import {MatMenuTrigger} from '@angular/material/menu';
import {Observable, of, Subject} from 'rxjs';
import {FilterMenusBase} from '@components/filter-bar/filter-menus-base';
import {AiAnalysisComponent} from '@module/favorites/popup/ai-analysis/ai-analysis.component';
import {PublishComponent} from '@module/favorites/popup/publish/publish.component';
import {ImageService} from '@services/image.service';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class ListComponent extends FilterMenusBase implements OnInit {

    listFavorite: FavoriteList[] = [];
    favoritesList: FavoriteList = EMPTY_FAVORITE_LIST;
    favorites: Favorite[] = [];

    loading = true;
    columsSelection = false;
    currentList;

    // Responsive : accordéons (indicateurs) uniquement en mobile ; desktop = à plat.
    isMobile = window.innerWidth < 768;
    openIndic: string = 'general'; // section indicateurs ouverte (mobile) : une seule à la fois

    // Filtres mobiles : panneau plein écran (même design que les filtres de la recherche)
    filtersFullscreen = false;

    // Popups mobiles (MatDialog ouverts sur des templates)
    @ViewChild('indicDialogTpl') indicDialogTpl: TemplateRef<any>;
    indicDialogRef: MatDialogRef<any>;

    // Vue active (switch Liste / Carte). La carte est embarquée -> pas de navigation, filtres conservés.
    view: 'list' | 'map' = 'list';
    // Filtres transmis à la carte embarquée (référence changée seulement quand les filtres changent).
    mapFilters: {
        title: string, status: string[], ville: string[],
        price_min: number, price_max: number,
        rendement_min: number, rendement_max: number
    } = {
        title: '', status: [], ville: [], price_min: null, price_max: null, rendement_min: null, rendement_max: null
    };

    // Pagination
    page = 1;
    perPage = 20;
    total = 0;

    user: User = Object.assign({}, EMPTY_USER);
    displayedColumns: string[] = [];
    sort = 'add-desc';
    sortOptions = [
        {value: 'add-desc', label: 'Date d\'enregistrement (Décroissant)'},
        {value: 'add-asc', label: 'Date d\'enregistrement (Croissant)'},
        {value: 'updated_at-desc', label: 'Date de modification (Décroissant)'},
        {value: 'updated_at-asc', label: 'Date de modification (Croissant)'},
        {value: 'price-desc', label: 'Prix (Décroissant)'},
        {value: 'price-asc', label: 'Prix (Croissant)'},
        {value: 'rendement-desc', label: 'Rendement (Décroissant)'},
        {value: 'rendement-asc', label: 'Rendement (Croissant)'},
    ];

    // Options fixes pour les filtres
    cities: City[] = [];
    status: string[] = ['analyse', 'contact', 'visite', 'offre', 'offre_ok', 'offre_ko', 'sell', 'abandon', 'offre_reponse', 'buy'];

    @ViewChild('titleTrigger') titleTrigger: MatMenuTrigger;
    @ViewChild('statusTrigger') statusTrigger: MatMenuTrigger;
    @ViewChild('villeTrigger') villeTrigger: MatMenuTrigger;
    @ViewChild('priceTrigger') priceTrigger: MatMenuTrigger;
    @ViewChild('rendementTrigger') rendementTrigger: MatMenuTrigger;

    sub_fav = null;

    // Filtres texte/select (avec debounce)
    searchForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
        status: new UntypedFormControl(null),
        ville: new UntypedFormControl(null),
    });

    // Filtres prix/rendement (appliqués au clic sur Appliquer / Rechercher)
    priceMin: number = null;
    priceMax: number = null;
    rendementMin: number = null;
    rendementMax: number = null;

    // Recherche dans le sélecteur de listes
    listSearchText = '';

    // Autocomplete villes — règle projet : debounce ~400ms avant l'API, jamais par frappe
    villeSearchText = '';
    private villeSearch$ = new Subject<string>();
    villeResults$: Observable<City[]> = of([]);
    selectedVilles: City[] = [];

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private titleService: Title,
        private alertService: AlertService,
        private userService: UserService,
        public adService: AdService,
        public onboardingService: OnboardingService,
        public authenticationService: AuthenticationService,
        public commonService: CommonService,
        public imageService: ImageService,
        public trackingService: TrackingService,
        public cityService: CityService,
    ) {
        super();
    }

    ngOnInit() {
        this.villeResults$ = this.cityService.autocomplete(this.villeSearch$);
        this.user = this.authenticationService.currentUser;
        if (this.authenticationService.currentUser.user_dashboard.favorite_kpi === undefined || this.authenticationService.currentUser.user_dashboard.favorite_kpi === null || this.authenticationService.currentUser.user_dashboard.favorite_kpi.length == 0 || !this.authenticationService.isAllowed('expert')) {
            this.displayedColumns = ['ad_city.price_diff', 'ad_city.demographie_annuelle', 'ad_city.carac_commune.mv', 'favorite.ad_city.renta', 'ad_city.carac_commune.te', 'ad_city.advice_price', 'amount_rent', 'ad_city.carac_commune.tc'];
        } else {
            this.displayedColumns = this.authenticationService.currentUser.user_dashboard.favorite_kpi;
        }

        // Les popups de filtres n'envoient rien pendant la saisie : l'application se fait
        // au clic sur « Appliquer » (desktop) ou « Rechercher » (panneau mobile).
        this.searchForm.valueChanges.subscribe(() => {
            this.trackingService.click('favorite_list_search_process', this.currentList);
        });

        this.route.params.subscribe(params => {
            this.loading = true;

            this.adService.getFavoritesLists().subscribe(result => {
                this.listFavorite = result;
            });
            this.currentList = params.id;
            this.sort = this.currentList === 'all' ? 'updated_at-desc' : 'add-desc';

            // Reset filtres et pagination au changement de liste
            this.page = 1;
            this.priceMin = null;
            this.priceMax = null;
            this.rendementMin = null;
            this.rendementMax = null;
            this.cities = [];
            this.selectedVilles = [];
            this.villeSearchText = '';
            // Vider via le flux — réassigner débrancherait le pipeline debounce
            this.villeSearch$.next('');
            this.searchForm.reset({title: '', status: null, ville: null}, {emitEvent: false});

            // Retour depuis un favori : restaure la page de la liste d'où l'on venait
            const returnPage = parseInt(this.route.snapshot.queryParams.page, 10);
            if (returnPage > 1) {
                this.page = returnPage;
            }

            this.loadFavorites();
        });

        // Retour depuis un favori (ancre #fav_...) : re-scrolle jusqu'à sa carte
        this.commonService.scrollToHashCard();
    }

    openAIAnalysis(favorite: Favorite): void {
        this.dialog.open(AiAnalysisComponent, {
            width: '780px',
            data: {favorite: favorite},
        });
    }

    loadFavorites() {
        this.loading = true;
        this.favorites = [];

        if (this.sub_fav) {
            this.sub_fav.unsubscribe();
        }

        const searchTerms = this.searchForm.getRawValue();
        const filters: any = {
            page: this.page,
            sort: this.sort
        };

        if (searchTerms.title && searchTerms.title !== '') {
            filters.title = searchTerms.title;
        }
        if (searchTerms.status && searchTerms.status.length > 0) {
            filters.status = searchTerms.status;
        }
        if (searchTerms.ville && searchTerms.ville.length > 0) {
            filters.ville = searchTerms.ville;
        }
        if (this.priceMin != null) {
            filters.price_min = this.priceMin;
        }
        if (this.priceMax != null) {
            filters.price_max = this.priceMax;
        }
        if (this.rendementMin != null) {
            filters.rendement_min = this.rendementMin;
        }
        if (this.rendementMax != null) {
            filters.rendement_max = this.rendementMax;
        }

        // Filtres partagés pour la carte embarquée (nouvelle référence => la carte se recharge).
        this.mapFilters = {
            title: filters.title || '',
            status: filters.status || [],
            ville: filters.ville || [],
            price_min: this.priceMin,
            price_max: this.priceMax,
            rendement_min: this.rendementMin,
            rendement_max: this.rendementMax,
        };

        this.sub_fav = this.adService.getFavoritesList(this.currentList, filters).subscribe(result => {
            result.favorites.forEach((fav, i) => {
                result.favorites[i] = this.adService.updateValues(fav);
            });
            this.favoritesList = result;
            this.favorites = result.favorites;
            this.total = result.total ?? result.favorites.length;
            this.page = result.page ?? this.page;
            this.titleService.setTitle('LyBox - ' + "Mes favoris " + this.favoritesList.title);

            // Enrichir les options villes depuis les résultats
            const existingCodes = new Set(this.cities.map(c => c.city_code));
            result.favorites.forEach(fav => {
                if (fav.ad_city && !existingCodes.has(fav.ad_city.city_code)) {
                    existingCodes.add(fav.ad_city.city_code);
                    this.cities.push(fav.ad_city);
                }
            });

            this.loading = false;

            if (result.favorites.length >= 1) {
                if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.favoris_list.status == 'not_started') {
                    this.onboardingService.startFavoriteList(this.currentList).subscribe();
                } else {
                    this.onboardingService.endFavoriteList();
                }
            }
        }, error => {
            if (error != 'token_outdate') {
                this.alertService.error('Liste introuvable', true);
                this.router.navigate(['/app/favorites']);
            }
        });
    }

    onSortChange() {
        this.trackingService.click('favorite_list_sort', this.sort);
        this.loadFavorites();
    }

    getSortLabel(): string {
        const opt = this.sortOptions.find(o => o.value === this.sort);
        return opt ? opt.label : 'Trier';
    }

    // Propriétaire de la liste (les listes non partagées sont les siennes)
    get isOwner(): boolean {
        return !this.favoritesList.share || '' + this.favoritesList.user_id === '' + this.user.id;
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.isMobile = window.innerWidth < 768;
    }

    // Accordéon indicateurs : mobile = exclusif ; desktop = tout ouvert (rien à faire).
    toggleIndic(key: string, e: Event) {
        e.preventDefault(); // on pilote l'ouverture via [open]
        if (this.isMobile) {
            this.openIndic = this.openIndic === key ? null : key;
        }
    }

    isIndicOpen(key: string): boolean {
        return !this.isMobile || this.openIndic === key;
    }

    // Accordéon filtres (popup mobile) : exclusif
    // Mobile : glissement depuis le bord gauche dans le panneau de filtres -> retour à la liste (geste natif)
    private touchStartX: number = null;
    private touchStartY: number = null;

    @HostListener('touchstart', ['$event'])
    onTouchStart(e: TouchEvent) {
        this.touchStartX = null;
        if (!this.filtersFullscreen) {
            return;
        }
        const t = e.touches[0];
        if (t.clientX <= 30) {
            this.touchStartX = t.clientX;
            this.touchStartY = t.clientY;
        }
    }

    @HostListener('touchend', ['$event'])
    onTouchEnd(e: TouchEvent) {
        if (this.touchStartX === null) {
            return;
        }
        const t = e.changedTouches[0];
        const dx = t.clientX - this.touchStartX;
        const dy = Math.abs(t.clientY - this.touchStartY);
        this.touchStartX = null;
        if (dx > 60 && dy < 50) {
            this.filtersFullscreen = false;
        }
    }

    // Tooltip du nom de ville (mobile) : uniquement si le nom est réellement tronqué (ellipsis)
    showCityTip(tip: {show: () => void}, e: Event) {
        const cityEl = (e.currentTarget as HTMLElement).closest('.city');
        if (cityEl && cityEl.scrollWidth > cityEl.clientWidth) {
            tip.show();
        }
    }

    // Curseur "help" seulement quand la ville est tronquée (indétectable en CSS pur)
    setCityCursor(e: Event) {
        const el = e.currentTarget as HTMLElement;
        const cityEl = el.closest('.city');
        el.style.cursor = cityEl && cityEl.scrollWidth > cityEl.clientWidth ? 'help' : '';
    }


    goToPage(p: number) {
        this.page = p;
        this.loadFavorites();
    }

    get pages(): number[] {
        const totalPages = Math.ceil(this.total / this.perPage);
        if (totalPages <= 1) { return []; }
        const result: number[] = [];
        for (let i = 1; i <= totalPages; i++) {
            result.push(i);
        }
        return result;
    }

    /**
     * Brouillon des popups de filtres : la popup édite l'état des filtres, mais rien
     * n'est chargé tant que « Appliquer » n'est pas cliqué. Fermer sans appliquer
     * restaure l'instantané pris à l'ouverture (sinon le chip afficherait un filtre
     * jamais appliqué).
     */
    private quickDraft: any = null;

    onFilterMenuOpened(trigger: MatMenuTrigger) {
        super.onFilterMenuOpened(trigger);
        this.quickDraft = {
            form: this.searchForm.getRawValue(),
            villes: this.selectedVilles.slice(),
            priceMin: this.priceMin,
            priceMax: this.priceMax,
            rendementMin: this.rendementMin,
            rendementMax: this.rendementMax,
        };
    }

    onFilterMenuClosed() {
        if (!this.quickDraft) {
            return;
        }
        const d = this.quickDraft;
        this.quickDraft = null;
        this.searchForm.setValue(d.form, {emitEvent: false});
        this.selectedVilles = d.villes;
        this.priceMin = d.priceMin;
        this.priceMax = d.priceMax;
        this.rendementMin = d.rendementMin;
        this.rendementMax = d.rendementMax;
    }

    /** « Appliquer » : valide le brouillon, ferme la popup et recharge la liste */
    applyQuickFilter(trigger: MatMenuTrigger) {
        this.quickDraft = null; // le brouillon devient l'état courant : pas de restauration
        trigger.closeMenu();
        this.page = 1;
        this.loadFavorites();
    }

    /** « Effacer » : vide le filtre de la popup ouverte, sans fermer ni recharger */
    clearQuickFilter(key: string) {
        switch (key) {
            case 'title':
                this.searchForm.get('title').setValue('', {emitEvent: false});
                break;
            case 'status':
                this.searchForm.get('status').setValue(null, {emitEvent: false});
                break;
            case 'ville':
                this.selectedVilles = [];
                this.villeSearchText = '';
                this.searchForm.get('ville').setValue(null, {emitEvent: false});
                break;
            case 'price':
                this.priceMin = null;
                this.priceMax = null;
                break;
            case 'rendement':
                this.rendementMin = null;
                this.rendementMax = null;
                break;
        }
    }

    clearFilters() {
        this.searchForm.reset({title: '', status: null, ville: null}, {emitEvent: false});
        // vide aussi les chips de villes, le champ de recherche et les résultats d'autocomplete du panneau
        this.selectedVilles = [];
        this.villeSearchText = '';
        this.villeSearch$.next('');
        this.priceMin = null;
        this.priceMax = null;
        this.rendementMin = null;
        this.rendementMax = null;
        this.page = 1;
        this.loadFavorites();
    }

    getActiveFilterCount(): number {
        let count = 0;
        const v = this.searchForm.getRawValue();
        if (v.title && v.title !== '') { count++; }
        if (v.status && v.status.length > 0) { count++; }
        if (v.ville && v.ville.length > 0) { count++; }
        if (this.priceMin != null || this.priceMax != null) { count++; }
        if (this.rendementMin != null || this.rendementMax != null) { count++; }
        return count;
    }

    getStatusLabel(): string {
        const selected = this.searchForm.get('status').value;
        if (!selected || selected.length === 0) { return ''; }
        const labels = selected.map(s => this.commonService.getStatusLib(s));
        const text = labels.join(', ');
        return text.length > 25 ? text.substring(0, 25) + '...' : text;
    }

    getPriceLabel(): string {
        const f = v => this.commonService.formatPrice(v);
        if (this.priceMin != null && this.priceMax != null) {
            return f(this.priceMin) + '-' + f(this.priceMax);
        }
        if (this.priceMin != null) { return '>' + f(this.priceMin); }
        if (this.priceMax != null) { return '<' + f(this.priceMax); }
        return '';
    }

    getRendementLabel(): string {
        if (this.rendementMin != null && this.rendementMax != null) {
            return this.rendementMin + '%-' + this.rendementMax + '%';
        }
        if (this.rendementMin != null) { return '>' + this.rendementMin + '%'; }
        if (this.rendementMax != null) { return '<' + this.rendementMax + '%'; }
        return '';
    }

    get isAllList(): boolean {
        return this.currentList === 'all';
    }

    get filteredListFavorite(): FavoriteList[] {
        const allList: FavoriteList = {
            id: 'all',
            title: 'Tous mes favoris',
            user_id: this.user.id,
            favorites: [],
            share: false,
            owner_name: ''
        };
        const lists = this.listSearchText
            ? this.listFavorite.filter(l => l.title.toLowerCase().includes(this.listSearchText.toLowerCase()))
            : this.listFavorite;

        // Aussi filtrer "Tous mes favoris" par la recherche
        if (this.listSearchText && !allList.title.toLowerCase().includes(this.listSearchText.toLowerCase())) {
            return lists;
        }
        return [allList, ...lists];
    }

    toggleStatus(value: string) {
        const current = this.searchForm.get('status').value || [];
        const index = current.indexOf(value);
        if (index >= 0) {
            current.splice(index, 1);
        } else {
            current.push(value);
        }
        this.searchForm.get('status').setValue(current.length > 0 ? [...current] : null);
    }

    isStatusSelected(value: string): boolean {
        const current = this.searchForm.get('status').value || [];
        return current.includes(value);
    }

    searchVilles(text: string) {
        this.villeSearchText = text;
        this.villeSearch$.next(text);
    }

    selectVille(city: City) {
        if (!this.selectedVilles.find(c => c.city_code === city.city_code)) {
            this.selectedVilles.push(city);
            const codes = this.selectedVilles.map(c => c.city_code);
            this.searchForm.get('ville').setValue(codes);
        }
        this.villeSearchText = '';
        this.villeSearch$.next('');
    }

    removeVille(city: City) {
        this.selectedVilles = this.selectedVilles.filter(c => c.city_code !== city.city_code);
        const codes = this.selectedVilles.map(c => c.city_code);
        this.searchForm.get('ville').setValue(codes.length > 0 ? codes : null);
    }

    openRenameDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }
        const dialogRef = this.dialog.open(RenamePopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result !== false) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('favorite_list_rename_confirm', this.currentList);
                this.favoritesList.title = result.title;
                this.listFavorite.forEach((f, i) => {
                    if (f.id === result.id) {
                        this.listFavorite[i].title = result.title;
                    }
                });
            } else {
                this.trackingService.click('favorite_list_rename_cancel', this.currentList);
            }
        });
    }

    openNewDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }
        const dialogRef = this.dialog.open(NewPopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result !== false) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('favorite_list_new_confirm', this.currentList);
                this.router.navigate(['/app/favorites', result]);
            } else {
                this.trackingService.click('favorite_list_new_cancel', this.currentList);
            }
        });
    }

    openShareDialog(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }

        const dialogRef = this.dialog.open(SharePopupComponent, {
            width: '420px',
            data: {favoritesList: this.favoritesList},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined && result !== false) {
                this.trackingService.click('favorite_list_share_confirm', this.currentList);
                this.alertService.success('Modification enregistrée.');
                this.listFavorite.forEach((f, i) => {
                    if (f.id === this.favoritesList.id) {
                        if (result.length == 0) {
                            this.listFavorite[i].share = false;
                        } else {
                            this.listFavorite[i].share = true;
                        }
                    }
                });
            } else {
                this.trackingService.click('favorite_list_share_cancel', this.currentList);
            }
        });
    }

    deleteFavoriteList(): void {
        if (this.favoritesList.user_id != this.user.id) {
            this.alertService.error('Seul le propriétaire de la liste peut effectuer cette action');
            return;
        }

        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer cette liste et perdre tous les favoris enregistrés ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.alertService.success("Suppression réussie.");
                this.trackingService.click('favorite_list_delete_confirm', this.currentList);
                this.trackingService.deleteFavoriteList();
                this.adService.deleteFavoriteList(this.favoritesList.id).subscribe(r => {
                    this.router.navigate(['/app/favorites']);
                });
            } else {
                this.trackingService.click('favorite_list_delete_cancel', this.currentList);
            }
        });
    }

    // Fermeture des menus de la barre (clic extérieur, ouverture d'un autre menu) :
    // héritée de FilterMenusBase, seule la liste des triggers est propre à la page
    protected filterMenuTriggers(): MatMenuTrigger[] {
        return [this.titleTrigger, this.statusTrigger, this.villeTrigger, this.priceTrigger, this.rendementTrigger];
    }

    displayColumsSelection() {
        // Mobile : popup à la norme du site ; desktop : carte inline d'origine
        if (this.isMobile) {
            this.indicDialogRef = this.dialog.open(this.indicDialogTpl, {autoFocus: false});
            return;
        }
        this.columsSelection = !this.columsSelection;
    }

    onColChange(val) {
        if (!this.authenticationService.isAllowed('expert')) {
            this.upgradePlan('assets/upgrade/indicateurs.png', 'Personnalisation des favoris', 'Expert');
        } else {
            this.trackingService.click('favorite_list_indicateur_change', this.currentList);
            if (_.difference(val, this.displayedColumns).length !== 0) {
                this.displayedColumns.push(_.difference(val, this.displayedColumns)[0]);
            } else if (_.difference(this.displayedColumns, val).length !== 0) {
                this.displayedColumns = _.without(this.displayedColumns, _.difference(this.displayedColumns, val)[0]);
            }
            this.user.user_dashboard.favorite_kpi = this.displayedColumns;
            this.userService.updateDashboard(this.user);
        }
    }

    upgradePlan(visuel = '', feature, plan) {
        this.trackingService.click('favorite_list_upgrade_plan', feature);
        if (!this.authenticationService.isLogin) {
            const dialogRef = this.dialog.open(LoginFormComponent, {
                width: '550px',
                data: {
                    disableClose: false
                },
            });
        } else {
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel, plan, feature}
                });
            }
        }
    }

    changeList() {
        this.favorites = [];
        this.router.navigate(['/app/favorites', this.currentList]);
    }

    compareAdd(favorite) {
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.upgradePlan('assets/upgrade/compare.png', 'Comparaison entre projets', 'Essentiel');
        } else {
            this.adService.getCompareAd().subscribe(ads => {
                if (ads.length >= 5) {
                    this.trackingService.click('favorite_list_compare_fail', this.currentList);
                    this.alertService.error('Comparaison limitée à 5 projets, veuillez supprimer un projet dans la comparaison.');
                } else {
                    this.trackingService.click('favorite_list_compare_success', this.currentList);
                    this.adService.addCompareAd(favorite.id);
                    this.alertService.success('Projet ajouté.');
                }
            });
        }
    }

    deleteFavorite(favorite): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer votre favoris "' + favorite.title + '" et perdre toutes les informations saisies ?'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.alertService.success("Suppression réussie.");
                this.trackingService.click('favorite_list_favorite_delete_confirm', this.currentList);
                this.trackingService.deleteFavorite();
                this.adService.deleteFavorite(favorite).subscribe(r => {
                    this.loadFavorites();
                });
            } else {
                this.trackingService.click('favorite_list_favorite_delete_cancel', this.currentList);
            }
        });
    }

    noteFavorite(favorite): void {
        const dialogRef = this.dialog.open(NotesComponent, {
            width: '420px',
            data: {favorite: favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                favorite.comment = result.comment;
            }
        });
    }

    // Publication partenaire sur le moteur de recherche (plan partenaire)
    publishFavorite(favorite: Favorite): void {
        const dialogRef = this.dialog.open(PublishComponent, {
            width: '480px',
            data: {favorite: favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                favorite.ad = result.ad;
                favorite.ad_id = result.ad_id;
            }
        });
    }

    orderList(): void {
        const dialogRef = this.dialog.open(OrderListPopupComponent, {
            width: '420px',
            data: {listFavorite: this.listFavorite},
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    moveFavorite(favorite): void {
        const dialogRef = this.dialog.open(AddComponent, {
            width: '420px',
            data: {favorite: favorite, mode: 'move'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Modification réussie.");
                this.trackingService.click('favorite_list_favorite_move_confirm', this.currentList);
                this.loadFavorites();
            } else {
                this.trackingService.click('favorite_list_favorite_move_cancel', this.currentList);
            }
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
